import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class FumbleFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return [
            FootballState.FumbleRecovered,
            FootballState.FumbleNotRecovered
        ].some((s) => s === fragment.associatedState);
    }

    getRawFragment(play, serializationContext, fumbleRecovery) {
        const fumble = play.getPreceedingFragment(fumbleRecovery, [
            FootballState.Fumble,
            FootballState.FieldGoalFumble
        ]);

        let rawPlay = "";
        if (fumbleRecovery?.recoveredBy && fumble?.forcedBy) {
            const forcedByUniform = this.resolveUniform(
                serializationContext,
                fumble.forcedBy
            );
            const recoveringUniform = this.resolveUniform(
                serializationContext,
                fumbleRecovery.recoveredBy
            );
            let values = [
                this.resolveTeam(
                    serializationContext,
                    fumbleRecovery.recoveredBy
                ),
                this.resolveFormattedFieldPosition(
                    serializationContext,
                    fumbleRecovery.recoveredAt
                ),
                recoveringUniform
            ];
            rawPlay = `FORCE:${forcedByUniform} FUMB:${values.join()}`;
        }

        return rawPlay;
    }
}
